// Basic Vue components
import { createApp } from 'vue'

// Setup Vue
window.Vue = createApp;
window.$ = window.jQuery = jQuery;

// Our extensions and components
import Axios from './classes/Axios.js';
import modalDynamic from './components/modal-dynamic.vue';

require ('./classes/PrototypeExt.js');

var app = createApp({

    components: {
      'modal-dynamic': modalDynamic,
    },

    data() {
        return {
            true: true,  // necessary to pass a boolean true and not a string
            false: false,  // necessary to pass a boolean true and not a string
            waiting: false,  // necessary to pass a boolean true and not a string
            modals: [],  // Dynamic modals
            openModals: 0,  // Dynamic modals counting
            buttonYesAction: [],
            buttonNoAction: [],
            button3Action: [],
            showLogin: false,
            showJson: false,

            username: '',
            password: '',
            shows: shows,
            sigmaApi: new Axios(shows[0].url),
            oasisApi: new Axios('https://www.revolutiones.com/oasis/restv2'),
            reportServer: 'https://jasper.revolutiones.com:8443/jasperserver/rest_v2/reports/Revolution/Phoenix/',
            showIndex: shows[0].id,
            showName: shows[0].name,
            showCompany: shows[0].company,
            showData: {},
            showToken: '',
            jsonOverride: '',

            // Report types
            costReport: false,
            trialBalance: false,
            tb: {},

            // DData to lead from theAPI
            transactionTypes: [ 
                { type: 'aps', name: "AP", include: true },
                { type: 'jes', name: "JE", include: true },
                { type: 'pos', name: "PO", include: false },
                { type: 'checks', name: "CK", include: false },
            ],

            includePOs: false,
            expensesOnly: false,

            codes: [
                'accounts',
                'series',
                'locations',
                'sets',
                'freefields',
                'insurances',
                'banks',
                'batches',
                'addresses',
                'countrytaxcodes',
                'periods',
                'productions',
                'currencies',
                'vendors',
                'states',
                'companies',
                'productions'
            ],
        }
    },

    methods: {
        testAuth() {

        },

        login() {
            // If here, the token was not available or invalid
            let data = {
                username: this.username,
                password: this.password,
            };

            this.sigmaApi.post('/auth', data)
                .then(response => {
                    if (response.status === 200 && response.data === false) {
                        // No data to retrive
                        return false;
                    } else if (response.status === 200 && typeof response.data === 'object') {
                        this.showToken = response.data.token;
                        this.showData[this.showName].token = response.data.token;
                        this.showData[this.showName].apiUrl = this.shows[0].url;
                        this.showLogin = false;
                    } else {
                        alert ('Login Failed. Please try again.');
                    }
                })
                .catch(error => { console.log(error); }
            );
        },

        forceDataReload() {
            this.refreshData(true)
                .then(response => console.log ('Done'))
                .catch(errors => console.log (errors))
            ;
        },

        refreshData(force, dateStart, dateEnd) {
            let datetimeStart = (dateStart) ? new Date(dateStart + 'T08:00:00Z') : new Date('01/01/1969');
            let datetimeEnd = (dateEnd) ? new Date(dateEnd + 'T08:00:00Z') : new Date('12/31/2099');

            this.waiting = true;
            return new Promise((resolve, reject) => {
                let forceReload = (force === true) ? true : false;

                this.showData[this.showName].accounts = this.showData[this.showName].ledger = this.showData[this.showName].aps = this.showData[this.showName].jes = 
                    this.showData[this.showName].pos = this.showData[this.showName].checks = this.showData[this.showName].pcs = this.showData[this.showName].budgetlines =
                    this.showData[this.showName].sortedAccounts = 
                    undefined;

                this.getCodes(forceReload)
                    .then(response => {
                        this.getData(forceReload)
                            .then(response => {
                                this.parseTransactions(datetimeStart, datetimeEnd);
                                if (this.expensesOnly === false) this.addChecks();
                                this.sortTrans();
                                localStorage.setItem('showData', JSON.stringify(this.showData));
                                this.waiting = false;
                                return resolve (true);
                            })
                            .catch(error => {
                                this.waiting = false;
                                console.log ("RefreshData Failure: getData");
                                return reject(error)
                            })
                    })
                    .catch(error => {
                        this.waiting = false;
                        console.log ("RefreshData Failure: getCodes");
                        return Promise.reject(error);
                    })
                ;
            })
        },

        sortTrans(field) {
            if (! field) field = 'trans_number';
            let unsorted = Object.assign({}, this.showData[this.showName].sortedAccounts);
            let sorted = [];

            for (let i in unsorted) {
                if (unsorted.hasOwnProperty(i)) {
                    sorted[i] = this.sortByProperty(unsorted[i], field);
                }
            };
            this.showData[this.showName].sortedAccounts = sorted;
        },

        getCodes(forceReload) {
            if (! this.showToken) {
                return Promise.reject ('No Token');
            }

            // Check localstorage
            let storedData = JSON.parse(localStorage.getItem('showData'));
            if (! forceReload && storedData && storedData[this.showName] && storedData[this.showName].accounts && storedData[this.showName].accounts.length > 0 &&
                storedData[this.showName].series && storedData[this.showName].series.length > 0 &&
                storedData[this.showName].batches && storedData[this.showName].batches.length > 0) {

                this.showData = storedData;
                return Promise.resolve(true);
            } else {
                let options = {
                    Authorization: 'Bearer ' + this.showToken
                };

                let scope = this;
                let data = [];
                this.codes.map((val) => {
                    data.push (
                        scope.getApiData('/' + val, options)
                            .then(response => {
                                scope.showData[scope.showName][val] = scope.stripDashes(response);
                                return (true);
                            })
                            .catch(error => {
                                console.log(error);
                                console.log ("getCodes Failure: getApiData " + val);
                                return Promise.reject(error);
                            }
                        )
                    );
                });

                return Promise.all(data)
                    .then(response => Promise.resolve(true)
                );

            }
        },

        getData(forceReload) {
            if (! this.showToken) {
                this.createDialog ({ "title": "Error", "body": "Please Login First.", "buttonNo": false, "buttonYesLabel": "OK"  });
                return Promise.reject ('No Token');
            }

            // Load from Cached Storage if available
            if (! forceReload && this.showData && this.showData[this.showName] && 
                this.showData[this.showName].aps && this.showData[this.showName].aps.length > 0 &&
                this.showData[this.showName].jes && this.showData[this.showName].jes.length > 0 ) {
                return Promise.resolve(true);
            } else {
                // otherwise load from the API
                let options = {
                    Authorization: 'Bearer ' + this.showToken
                };

                let scope = this;
                let data = [];
                let types = Object.keys(this.transactionTypes).map(key => this.transactionTypes[key].type)
                types.map((val) => {
                    data.push (
                        scope.getApiData('/' + val, options)
                            .then(response => {
                                // console.log(response);
                                scope.showData[scope.showName][val] = scope.stripDashes(response);
                                return (true);
                            })
                            .catch(error => {
                                console.log(error);
                                console.log ("getData Failure: getApiData " + val);
                                return (false);
                            })

                    );
                });

                return Promise.all(data)
                    .then(response => Promise.resolve(true))
                    .catch(error => Promise.reject(error))
                ;
            }
        },

        getApiData(endpoint, options) {
            if (! this.showToken) {
                return Promise.reject ('No Token');
            }

            let result = [];

            let recursive = page => this.sigmaApi.get(endpoint + page, requestData, options)
                .then(response => {
                    if (response.status === 200 && response.data.results) {
                        result = result.concat(response.data.results);
                        if (response.data.next) {
                            let nextPage = response.data.next.replace(this.showData[this.showName].apiUrl + endpoint,'');
                            return recursive(nextPage);
                        } else {
                            return result;
                        }
                    } else if (response.status === 401) {
                        this.showToken = this.showData[this.showName].token = undefined;
                        localStorage.clear();
                        location.reload();
                        return Promise.reject ("Auth");
                    } else {
                        return false;
                    }
                })
                .catch(error => {
                    console.log ("getApiData Failure: " + endpoint);
                    return Promise.reject (error);
                });

            return recursive('');
        },

        stripDashes(object){
            return object;
            for (let i=0; i < object.length; i++) {

            }
        },

        buildTB(dateStart, dateEnd) {
            this.includePOs = false;
            this.expensesOnly = false;
            this.refreshData(false, dateStart, dateEnd)
                .then(response => {
                    // Basic report output frame
                    let json = { 
                        "report": {
                            "report_title": "Trial Balance Summary",
                            "report_subtitle": (dateStart && dateEnd) ? dateStart + ' &mdash; ' + dateEnd : null,
                            "report_name": "trial_balance_summary",
                            "printed_by": this.username,
                            "date_run": this.today(),
                            "project": this.showName,
                            "company": this.showCompany,
                            "period": "All",
                            "currency": "US",
                            "date_start": "ALL",
                            "date_end": "ALL",
                            "total_beginning": 0,
                            "total_current": 0,
                            "total_ending": 0,
                            "data": []
                        }
                    },
                    // this is the data portion of the report
                    tb = [
                        { 'assets': { group: "ASSETS", group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] } },
                        { 'liabilities': { group: "LIABILITIES", group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] } },
                        { 'income': { group: "INCOME", group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] } },
                        { 'expenses': { group: "EXPENSES", group_beginning: 0, group_current: 0, group_ending: 0, account_headers: [] } },
                    ],

                    // group accounts by account type
                    groups = {
                        "assets": (this.showData[this.showName].accounts.filter(( {type} ) => { return (type === 'ASSET'); })),
                        "liabilities": (this.showData[this.showName].accounts.filter(( {type} ) => { return (type === 'LIABILITY'); })),
                        "income": (this.showData[this.showName].accounts.filter(( {type} ) => { return (type === 'INCOME'); })),
                        "expenses": (this.showData[this.showName].accounts.filter(( {type} ) => { return (type.match('EXPENSE')); })),
                    };

                    // Wait for filtering of groups to complete then build out data
                    Promise.all(Object.values(groups))
                        .then(responses => {
                            console.log(Object.keys(groups))
                            Object.keys(groups).forEach((group, index) => {
                                // console.log ("INDEX:" + index);
                                // console.log (group);
                                groups[group].forEach((data, ind) => {
                                    let account = {};
                                    account.account_header_name = data.name;
                                    account.account_header = data.code;
                                    account.account_id = data.id;
                                    account.account_parent = data.parent;
                                    account.account_header_beginning = 0.00;

                                    // Now look through actual data
                                    if (this.showData[this.showName].sortedAccounts[data.code]) {
                                        account.account_header_current = account.account_header_ending = this.sumRecursive(this.showData[this.showName].sortedAccounts[data.code], 'amount');
                                        account.accounts = this.showData[this.showName].sortedAccounts[data.code];
                                        tb.find((data,ind) => { return (Object.keys(data) == group)})[group].account_headers.push(account);
                                    }
                                });

                                let tbal = tb.find((data,ind) => { return (Object.keys(data) == group)})[group];
                                let groupSum = this.sumRecursive(tbal.account_headers, 'account_header_current');
                                tbal.group_current = tbal.group_ending = groupSum
                            });

                            tb.map((val) => json.report.data.push(Object.values(val)[0]));

                            let totalSum = this.sumRecursive(json.report.data, 'group_current');
                            json.report.total_current = json.report.total_ending = totalSum;
                            // console.log ('Result: ' ); console.log(responses); console.log(groups);

                            this.jsonOverride = JSON.stringify(json, null, 2); // spacing level = 2

                            this.getJson(json)
                                .then(response => {
                                    let report = this.reportServer + json.report.report_name + '.pdf?net.sf.jasperreports.json.source=' + response;
                                    let preview = this.reportServer + json.report.report_name + '.html?net.sf.jasperreports.json.source=' + response;
                                    console.log(preview);
                                    this.getReport(report)
                                        .then(reportUrl => this.createDialog({ "title": "Success", "body": 'Please click to view your report: <a href="' + reportUrl + '" target="_reports">Click to View</a>', "buttonNo": false, "buttonYesLabel": "OK"  })
                                    );
                                })
                                .catch(error => console.log(error));
                            ;
                        }
                    );
                })
                .catch(errors => console.log(errors))
            ;
        },

        buildBible() {
            this.refreshData()
                .then(response => {
                    let rawData = [];

                    this.showData[this.showName].accounts.map((data) => {
                        let account = {};

                        account.account_desc = data.name;
                        account.account_number = data.code;
                        account.account_id = data.id;
                        account.account_parent = data.parent;
                        if (this.showData[this.showName].sortedAccounts[data.code]) {
                            account.account_total = this.sumRecursive(this.showData[this.showName].sortedAccounts[data.code], 'amount');
                            account.transaction = this.showData[this.showName].sortedAccounts[data.code];
                            rawData.push(account);
                        }
                    });
                    // console.log (rawData);
                    let grandTotal = this.sumRecursive(rawData, 'account_total');

                    let json = { 
                        "report": {
                            "report_title": "General Ledger Detail",
                            "report_subtitle": null,
                            "report_name": "general_ledger_detail",
                            "printed_by": this.username,
                            "date_run": this.today(),
                            "project": this.showName,
                            "company": this.showCompany,
                            "period": "All",
                            "currency": "US",
                            "grand_total": grandTotal,
                            "data": []
                        }
                    };

                    json.report.data = rawData;
                    this.jsonOverride = JSON.stringify(json, null, 2); // spacing level = 2

                    this.getJson(json)
                        .then(response => {
                            let report = this.reportServer + json.report.report_name + '.pdf?net.sf.jasperreports.json.source=' + response;
                            let preview = this.reportServer + json.report.report_name + '.html?net.sf.jasperreports.json.source=' + response;
                            console.log(preview);
                            this.getReport(report)
                                .then(reportUrl => this.createDialog({ "title": "Success", "body": 'Please click to view your report: <a href="' + reportUrl + '" target="_reports">Click to View</a>', "buttonNo": false, "buttonYesLabel": "OK"  })
                            );
                        })
                        .catch(error => console.log(error));
                    ;
                })
                .catch(errors => console.log(errors))
            ;
        },

        buildAllPos() {
            this.includePOs = true;
            this.refreshData()
                .then(response => {
                    let rawData = [];

                    this.showData[this.showName].pos.map((data) => {
                        let transaction = {};

                        if (data.lines && data.lines.length > 0 ) {
                            transaction.trans_number = data.number;
                            transaction.transaction_type = 'PO';
                            transaction.transaction_desc = data.description;
                            transaction.document_amount = data.remaining;
                            transaction.doc_number = data.number;
                            transaction.doc_date = data.date;
                            transaction.effective_date = data.effective_date;
                            transaction.vendor = (data.vendor) ? this.showData[this.showName].vendors.find(( {id} ) => { return (id === data.vendor); }).name : null;
                            transaction.detail = [];

                            for (let line of data.lines) {
                                // lookup code by user code, not id
                                let code = this.showData[this.showName].accounts.find(( {id} ) => { return (id === line.account) }).code
                                // let typeLabel = this.transactionTypes.find (( {type} ) => type === transType).name
                                let accountType = this.showData[this.showName].accounts.find(( {id} ) => { return (id === line.account) }).type
                                let lineFixed = this.transformLine(line, data, 'PO');

                                // lookup/transform data to the line
                                if (lineFixed != undefined) {
                                    transaction.detail.push(lineFixed);
                                }
                            };
                        }
                        if (transaction.detail && transaction.detail.length > 0) rawData.push(transaction);
                    });
                    // console.log (rawData);
                    let grandTotal = this.sumRecursive(rawData, 'document_amount');
                    let numItems = rawData.length;

                    let json = { 
                        "report": {
                            "report_title": "All Purchase Orders",
                            "report_subtitle": "Sorted by Transaction",
                            "report_name": "po_open_transaction",
                            "printed_by": this.username,
                            "date_run": this.today(),
                            "project": this.showName,
                            "company": this.showCompany,
                            "period": "All",
                            "currency": "US",
                            "ids": numItems,
                            "grand_total": grandTotal,
                            "data": []
                        }
                    };

                    let sorted = this.sortByProperty(rawData, 'trans_number');

                    json.report.data = sorted;
                    this.jsonOverride = JSON.stringify(json, null, 2); // spacing level = 2

                    this.getJson(json)
                        .then(response => {
                            let report = this.reportServer + json.report.report_name + '.pdf?net.sf.jasperreports.json.source=' + response;
                            let preview = this.reportServer + json.report.report_name + '.html?net.sf.jasperreports.json.source=' + response;
                            console.log(preview);
                            this.getReport(report)
                                .then(reportUrl => this.createDialog({ "title": "Success", "body": 'Please click to view your report: <a href="' + reportUrl + '" target="_reports">Click to View</a>', "buttonNo": false, "buttonYesLabel": "OK"  })
                            );
                        })
                        .catch(error => console.log(error));
                    ;
                })
                .catch(errors => console.log(errors))
            ;
        },

        buildPos() {
            this.includePOs = true;
            this.refreshData()
                .then(response => {
                    let rawData = [];

                    this.showData[this.showName].pos.map((data) => {
                        let transaction = {};

                        if (data.lines && data.lines.length > 0 && (data.status === 'POSTED' || data.status === 'VOIDED')) {
                            transaction.trans_number = data.number;
                            transaction.transaction_type = 'PO';
                            transaction.transaction_desc = data.description;
                            transaction.document_amount = data.remaining;
                            transaction.doc_number = data.number;
                            transaction.doc_date = data.date;
                            transaction.effective_date = data.effective_date;
                            transaction.vendor = (data.vendor) ? this.showData[this.showName].vendors.find(( {id} ) => { return (id === data.vendor); }).name : null;
                            transaction.detail = [];

                            for (let line of data.lines) {
                                // lookup code by user code, not id
                                let code = this.showData[this.showName].accounts.find(( {id} ) => { return (id === line.account) }).code
                                let accountType = this.showData[this.showName].accounts.find(( {id} ) => { return (id === line.account) }).type
                                let lineFixed = this.transformLine(line, data, 'PO');

                                // lookup/transform data to the line
                                if (lineFixed != undefined) {
                                    transaction.detail.push(lineFixed);
                                }
                            };
                        }
                        if (transaction.detail && transaction.detail.length > 0) rawData.push(transaction);
                    });
                    // console.log (rawData);
                    let grandTotal = this.sumRecursive(rawData, 'document_amount');
                    let numItems = rawData.length;

                    let json = { 
                        "report": {
                            "report_title": "Open Purchase Orders",
                            "report_subtitle": "Sorted by Transaction",
                            "report_name": "po_open_transaction",
                            "printed_by": this.username,
                            "date_run": this.today(),
                            "project": this.showName,
                            "company": this.showCompany,
                            "period": "All",
                            "currency": "US",
                            "ids": numItems,
                            "grand_total": grandTotal,
                            "data": []
                        }
                    };

                    let sorted = this.sortByProperty(rawData, 'trans_number');

                    json.report.data = sorted;
                    this.jsonOverride = JSON.stringify(json, null, 2); // spacing level = 2

                    this.getJson(json)
                        .then(response => {
                            let report = this.reportServer + json.report.report_name + '.pdf?net.sf.jasperreports.json.source=' + response;
                            let preview = this.reportServer + json.report.report_name + '.html?net.sf.jasperreports.json.source=' + response;
                            console.log(preview);
                            this.getReport(report)
                                .then(reportUrl => this.createDialog({ "title": "Success", "body": 'Please click to view your report: <a href="' + reportUrl + '" target="_reports">Click to View</a>', "buttonNo": false, "buttonYesLabel": "OK"  })
                            );
                        })
                        .catch(error => console.log(error));
                    ;
                })
                .catch(errors => console.log(errors))
            ;
        },

        buildPosAccount() {
            this.includePOs = true;
            this.refreshData()
                .then(response => {
                    let rawData = [];

                    this.showData[this.showName].accounts.map((data) => {
                        let account = {};

                        account.account_desc = data.name;
                        account.account_number = data.code;
                        account.account_id = data.id;
                        account.account_parent = data.parent;

                        let posOnly = {};
                        if (this.showData[this.showName].sortedAccounts[data.code]) {
                            posOnly[data.code] = [];
                            this.showData[this.showName].sortedAccounts[data.code].map((transactions) => {
                                if (transactions.trans_type === 'PO') {
                                    posOnly[data.code].push (transactions);
                                }
                            });

                            if (posOnly[data.code].length > 0) {
                                account.transaction = posOnly[data.code];
                                account.account_total = this.sumRecursive(posOnly[data.code], 'amount');
                                rawData.push(account);
                            }
                        }
                    });
                    // console.log (rawData);
                    let grandTotal = this.sumRecursive(rawData, 'account_total');

                    let json = { 
                        "report": {
                            "report_title": "Purchase Order Detail",
                            "report_subtitle": null,
                            "report_name": "general_ledger_detail",
                            "printed_by": this.username,
                            "date_run": this.today(),
                            "project": this.showName,
                            "company": this.showCompany,
                            "period": "All",
                            "currency": "US",
                            "grand_total": grandTotal,
                            "data": []
                        }
                    };

                    json.report.data = rawData;
                    this.jsonOverride = JSON.stringify(json, null, 2); // spacing level = 2

                    this.getJson(json)
                        .then(response => {
                            let report = this.reportServer + json.report.report_name + '.pdf?net.sf.jasperreports.json.source=' + response;
                            let preview = this.reportServer + json.report.report_name + '.html?net.sf.jasperreports.json.source=' + response;
                            console.log(preview);
                            this.getReport(report)
                                .then(reportUrl => this.createDialog({ "title": "Success", "body": 'Please click to view your report: <a href="' + reportUrl + '" target="_reports">Click to View</a>', "buttonNo": false, "buttonYesLabel": "OK"  })
                            );
                        })
                        .catch(error => console.log(error));
                    ;
                })
                .catch(errors => console.log(errors))
            ;
        },

        buildCheckData() {
            let checkData = [];

            // Go through checks
            this.showData[this.showName].checks.map((data) => {
                let check = {};

                check.payment_number = data.number;
                check.payment_date = data.date;
                check.payment_payee = (data.vendor) ? this.showData[this.showName].vendors.find(( {id} ) => { return (id === data.vendor); }).name : null;
                check.payment_desc = data.description;
                check.payment_amount = data.amount_decimal;
                check.payment_status = data.status;

                if (data.status === 'POSTED' || data.status === 'CLOSED') {
                    check.payment_status = 'PRINTED';
                    checkData.push(check);
                } else if (data.status === 'VOIDED') {
                    check.payment_amount = 0.00;
                    checkData.push(check);
                } else {
                    // skip draft for now.
                }
            });

            // Add Manual Checks
            let manualCheckData = this.showData[this.showName].aps.filter( ({payment_type}) => payment_type === 'CHECK_MANUAL' );
            manualCheckData.map((data) => {
                let check = {};

                check.payment_number = data.payment_confirmation_number;
                check.payment_date = data.date;
                check.payment_payee = (data.vendor) ? this.showData[this.showName].vendors.find(( {id} ) => { return (id === data.vendor); }).name : null;
                check.payment_desc = data.description;
                check.payment_amount = data.amount_decimal;
                check.payment_status = data.status;

                if (data.status === 'POSTED' && data.status === 'CLOSED') {
                    check.payment_status = 'MANUAL';
                    checkData.push(check);
                } else if (data.status === 'VOIDED') {
                    check.payment_amount = 0.00;
                    checkData.push(check);
                } else {
                }
            });

            return checkData;
        },

        buildCheckRegister() {
            this.refreshData()
                .then(response => {
                    let rawData = this.buildCheckData();

                    // console.log (rawData);
                    let grandTotal = this.sumRecursive(rawData, 'payment_amount');

                    let json = { 
                        "report": {
                            "report_title": "Check Register Summary",
                            "report_subtitle": null,
                            "report_name": "check_register_summary",
                            "printed_by": this.username,
                            "date_run": this.today(),
                            "project": this.showName,
                            "company": this.showCompany,
                            "period": "All",
                            "currency": "US",
                            "grand_total": grandTotal,
                            "data": []
                        }
                    };

                    let sorted = this.sortByProperty(rawData, 'payment_number');

                    json.report.data = sorted;
                    this.jsonOverride = JSON.stringify(json, null, 2); // spacing level = 2

                    this.getJson(json)
                        .then(response => {
                            let report = this.reportServer + json.report.report_name + '.pdf?net.sf.jasperreports.json.source=' + response;
                            let preview = this.reportServer + json.report.report_name + '.html?net.sf.jasperreports.json.source=' + response;
                            console.log(preview);
                            this.getReport(report)
                                .then(reportUrl => this.createDialog({ "title": "Success", "body": 'Please click to view your report: <a href="' + reportUrl + '" target="_reports">Click to View</a>', "buttonNo": false, "buttonYesLabel": "OK"  })
                            );
                        })
                        .catch(error => console.log(error));
                    ;
                })
                .catch(errors => console.log(errors))
            ;
        },

        buildCostReport() {
            this.showData[this.showName].budgetlines.filter(
                ({account, budget, efc, etc, overages, variance, id, committed_costs, costs_to_date}) => {
                    let code = this.showData[this.showName].accounts.find(( {id} ) => { return (id === account); }).code;
                    console.log (id, budget, code, account, efc, etc, overages, variance, committed_costs, costs_to_date)
                });
        },

        build1099Data(taxYear, taxableOnly) {
            if (! taxYear) taxYear = 2017;
            if (! taxableOnly) taxableOnly = false;
            let checkData = this.buildCheckData();
            let vendors = {};
            let rawData = [];

            let transactionData = {};

                    // Loop through our transaction data (in sortedAccounts)
                    this.showData[this.showName].accounts.map((accountData) => {
                        // Look only for expense accounts
                        if (this.showData[this.showName].sortedAccounts[accountData.code] && accountData.type.match(/^EXPENSE/)) {

                            // Sift through transaction data
                            this.showData[this.showName].sortedAccounts[accountData.code].map((trx) => {
                                // If a tax code exists and check is paid and is in the tax year, add to report
                                if (trx.vendor_id && 
                                    trx.payment_number &&
                                    checkData.find( ( {payment_number, payment_date} ) => { return (payment_number == trx.payment_number &&
                                    (new Date(payment_date)).getFullYear() == taxYear) })
                                ) {
                                    if (taxableOnly && ! trx.tax_code) {
                                        // do nothing 
                                    } else {
                                        if (! transactionData.hasOwnProperty(trx.vendor_id)) {
                                            transactionData[trx.vendor_id] = [];
                                        }

                                        transactionData[trx.vendor_id].push(trx);

                                        // Create summary/totals
                                        if (vendors.hasOwnProperty(trx.vendor_id)) {
                                            vendors[trx.vendor_id].total += parseFloat(trx.amount);
                                        } else {
                                            vendors[trx.vendor_id] = {};
                                            vendors[trx.vendor_id].total = parseFloat(trx.amount);
                                            vendors[trx.vendor_id].taxable = 0;
                                            vendors[trx.vendor_id].nontaxable = 0;
                                        }

                                        if (trx.tax_code && vendors[trx.vendor_id].hasOwnProperty(trx.tax_code)) {
                                            vendors[trx.vendor_id][trx.tax_code] += parseFloat(trx.amount);
                                            vendors[trx.vendor_id].taxable += parseFloat(trx.amount);
                                        } else if (trx.tax_code) {
                                            vendors[trx.vendor_id][trx.tax_code] = parseFloat(trx.amount);
                                            vendors[trx.vendor_id].taxable += parseFloat(trx.amount);
                                        } else if (! taxableOnly && vendors[trx.vendor_id].hasOwnProperty('nontaxable')) {
                                            vendors[trx.vendor_id].nontaxable += parseFloat(trx.amount);
                                        } else if (! taxableOnly ) {
                                            vendors[trx.vendor_id].nontaxable = parseFloat(trx.amount);
                                        } else {
                                            // vendors[trx.vendor_id].nontaxable = parseFloat(trx.amount);
                                        }
                                    }

                                }
                            });
                        }
                    });

                    // Now go through results and build dataset
                    for (let vendor_id in transactionData) {
                        // Lookup vendor info and map.
                        let vendorData = this.showData[this.showName].vendors.find(( {id} ) => id == vendor_id);

                        let vendor = {};
                        vendor.company = this.showData[this.showName].companies[0].name;
                        vendor.company_address_1 = this.showData[this.showName].companies[0].address.line1;
                        vendor.company_address_2 = this.showData[this.showName].companies[0].address.line2;
                        vendor.company_city = this.showData[this.showName].companies[0].address.city;
                        vendor.company_state = this.showData[this.showName].states.find(( {id, state} ) => id == this.showData[this.showName].companies[0].address.state).code;
                        vendor.company_zip = this.showData[this.showName].companies[0].address.postal;
                        vendor.company_tel = this.showData[this.showName].companies[0].phone;
                        vendor.company_tax_id = this.showData[this.showName].companies[0].tax_id;
                        vendor.vendor_number = (vendorData.code) ? vendorData.code : '';
                        vendor.vendor_account_number = (vendorData.account_number) ? vendorData.account_number : '';
                        vendor.vendor_name = vendorData.name;
                        vendor.tax_id = vendorData.tax_id;
                        vendor.vendor_alias = vendorData.alias_name;
                        vendor.vendor_type = vendorData.entity_type;
                        vendor.work_state = vendorData.work_state;
                        vendor.address_1 = vendorData.address_contact.line1;
                        vendor.address_2 = vendorData.address_contact.line2;
                        vendor.city = vendorData.address_contact.city;
                        vendor.state = this.showData[this.showName].states.find(( {id, state} ) => id == vendorData.address_contact.state).code;
                        vendor.zip = vendorData.address_contact.postal;
                        vendor.w9 = (vendorData.w9) ? 1 : 0;
                        vendor.code01_total = (vendors[vendor_id]['1099-1']) ? vendors[vendor_id]['1099-1'].toFixed(2) : '0.00';
                        vendor.code02_total = (vendors[vendor_id]['1099-2']) ? vendors[vendor_id]['1099-2'].toFixed(2) : '0.00';
                        vendor.code03_total = (vendors[vendor_id]['1099-3']) ? vendors[vendor_id]['1099-3'].toFixed(2) : '0.00';
                        vendor.code04_total = (vendors[vendor_id]['1099-4']) ? vendors[vendor_id]['1099-4'].toFixed(2) : '0.00';
                        vendor.code05_total = (vendors[vendor_id]['1099-5']) ? vendors[vendor_id]['1099-5'].toFixed(2) : '0.00';
                        vendor.code06_total = (vendors[vendor_id]['1099-6']) ? vendors[vendor_id]['1099-6'].toFixed(2) : '0.00';
                        vendor.code07_total = (vendors[vendor_id]['1099-7']) ? vendors[vendor_id]['1099-7'].toFixed(2) : '0.00';
                        vendor.code08_total = (vendors[vendor_id]['1099-8']) ? vendors[vendor_id]['1099-8'].toFixed(2) : '0.00';
                        vendor.code09_total = null;
                        vendor.code10_total = (vendors[vendor_id]['1099-10']) ? vendors[vendor_id]['1099-10'].toFixed(2) : '0.00';
                        vendor.code11_total = (vendors[vendor_id]['1099-11']) ? vendors[vendor_id]['1099-11'].toFixed(2) : '0.00';
                        vendor.code12_total = (vendors[vendor_id]['1099-12']) ? vendors[vendor_id]['1099-12'].toFixed(2) : '0.00';
                        vendor.code13_total = (vendors[vendor_id]['1099-13']) ? vendors[vendor_id]['1099-13'].toFixed(2) : '0.00';
                        vendor.code14_total = (vendors[vendor_id]['1099-14']) ? vendors[vendor_id]['1099-14'].toFixed(2) : '0.00';
                        vendor.code15_total = (vendors[vendor_id]['1099-15']) ? vendors[vendor_id]['1099-15'].toFixed(2) : '0.00';
                        vendor.taxable_total = (vendors[vendor_id]['taxable']) ? vendors[vendor_id]['taxable'].toFixed(2) : '0.00';
                        vendor.nontax_total = (vendors[vendor_id]['nontaxable']) ? vendors[vendor_id]['nontaxable'].toFixed(2) : '0.00';
                        vendor.vendor_total = (vendors[vendor_id]['total']) ? vendors[vendor_id]['total'].toFixed(2) : '0.00';
                        vendor.vendor_total_paid = 0;
                        vendor.details = transactionData[vendor_id];
                        rawData.push(vendor);
                    }

                    console.log (vendors);
                    return (rawData);
        },

        build1099Misc(taxYear) {
            if (! taxYear) taxYear = 2017;
            let taxableOnly = true;
            let rawData = '';
            this.includePOs = false;
            this.refreshData()
                .then(response => {
                    let rawData = this.build1099Data(taxYear, taxableOnly)
                    let json = { 
                        "report": {
                            "report_title": "1099 Missing Vendor Info Report",
                            "report_subtitle": "Listed by Vendor",
                            "report_name": "1099_misc_2017",
                            "printed_by": this.username,
                            "date_run": this.today(),
                            "project": this.showName,
                            "company": this.showCompany,
                            "period": "All",
                            "currency": "US",
                            "tax_year": taxYear,
                            "data": []
                        }
                    };

                    json.report.data = rawData;
                    this.jsonOverride = JSON.stringify(json, null, 2); // spacing level = 2

                    this.getJson(json)
                        .then(response => {
                            let report = this.reportServer + 'Test/' + json.report.report_name + '.pdf?net.sf.jasperreports.json.source=' + response;
                            let preview = this.reportServer + 'Test/' + json.report.report_name + '.html?net.sf.jasperreports.json.source=' + response;
                            console.log(preview);
                            this.getReport(report)
                                .then(reportUrl => this.createDialog({ "title": "Success", "body": 'Please click to view your report: <a href="' + reportUrl + '" target="_reports">Click to View</a>', "buttonNo": false, "buttonYesLabel": "OK"  })
                            );
                        })
                        .catch(error => console.log(error));
                    ;

                    })
                .catch(errors => console.log(errors))
            ;
        },

        build1099Report(taxYear) {
            if (! taxYear) taxYear = 2017;
            let taxableOnly = true;
            let rawData = '';
            this.includePOs = false;
            this.refreshData()
                .then(response => {
                    let rawData = this.build1099Data(taxYear, taxableOnly)
                    let json = { 
                        "report": {
                            "report_title": "1099 Info Report",
                            "report_subtitle": "Listed by Vendor",
                            "report_name": "1099_detail",
                            "printed_by": this.username,
                            "date_run": this.today(),
                            "project": this.showName,
                            "company": this.showCompany,
                            "period": "All",
                            "currency": "US",
                            "tax_year": taxYear,
                            "company": this.showData[this.showName].companies[0].name,
                            "company_address_1": this.showData[this.showName].companies[0].address.line1,
                            "company_address_2": this.showData[this.showName].companies[0].address.line2,
                            "company_city": this.showData[this.showName].companies[0].address.city,
                            "company_state": this.showData[this.showName].states.find(( {id, state} ) => id == this.showData[this.showName].companies[0].address.state).code,
                            "company_zip": this.showData[this.showName].companies[0].address.postal,
                            "company_tel": this.showData[this.showName].companies[0].phone,
                            "company_tax_id": this.showData[this.showName].companies[0].tax_id,
                            "data": []
                        }
                    };

                    json.report.data = rawData;
                    this.jsonOverride = JSON.stringify(json, null, 2); // spacing level = 2

                    this.getJson(json)
                        .then(response => {
                            let report = this.reportServer + 'Test/' + json.report.report_name + '.pdf?net.sf.jasperreports.json.source=' + response;
                            let preview = this.reportServer + 'Test/' + json.report.report_name + '.html?net.sf.jasperreports.json.source=' + response;
                            console.log(preview);
                            this.getReport(report)
                                .then(reportUrl => this.createDialog({ "title": "Success", "body": 'Please click to view your report: <a href="' + reportUrl + '" target="_reports">Click to View</a>', "buttonNo": false, "buttonYesLabel": "OK"  })
                            );
                        })
                        .catch(error => console.log(error));
                    ;

                    })
                .catch(errors => console.log(errors))
            ;
        },

        buildVendorReport(taxYear) {
            if (! taxYear) taxYear = 2017;
            let taxableOnly = false;
            let rawData = '';
            this.includePOs = false;
            this.refreshData()
                .then(response => {
                    let rawData = this.build1099Data(taxYear, taxableOnly)

                    // let grandTotal = this.sumRecursive(rawData, 'taxable_total');
                    let json = { 
                        "report": {
                            "report_title": "Vendor Info Report" + ((taxYear) ? " for " + taxYear : ''),
                            "report_subtitle": "Listed by Vendor",
                            "report_name": "1099_detail",
                            "printed_by": this.username,
                            "date_run": this.today(),
                            "project": this.showName,
                            "company": this.showCompany,
                            "period": "All",
                            "currency": "US",
                            "tax_year": taxYear,
                            "company": this.showData[this.showName].companies[0].name,
                            "company_address_1": this.showData[this.showName].companies[0].address.line1,
                            "company_address_2": this.showData[this.showName].companies[0].address.line2,
                            "company_city": this.showData[this.showName].companies[0].address.city,
                            "company_state": this.showData[this.showName].states.find(( {id, state} ) => id == this.showData[this.showName].companies[0].address.state).code,
                            "company_zip": this.showData[this.showName].companies[0].address.postal,
                            "company_tel": this.showData[this.showName].companies[0].phone,
                            "company_tax_id": this.showData[this.showName].companies[0].tax_id,
                            "data": []
                        }
                    };

                    json.report.data = rawData;
                    this.jsonOverride = JSON.stringify(json, null, 2); // spacing level = 2

                    this.getJson(json)
                        .then(response => {
                            let report = this.reportServer + 'Test/' + json.report.report_name + '.pdf?net.sf.jasperreports.json.source=' + response;
                            let preview = this.reportServer + 'Test/' + json.report.report_name + '.html?net.sf.jasperreports.json.source=' + response;
                            console.log(preview);
                            this.getReport(report)
                                .then(reportUrl => this.createDialog({ "title": "Success", "body": 'Please click to view your report: <a href="' + reportUrl + '" target="_reports">Click to View</a>', "buttonNo": false, "buttonYesLabel": "OK"  })
                            );
                        })
                        .catch(error => console.log(error));
                    ;

                    })
                .catch(errors => console.log(errors))
            ;
        },

        buildReportCustom() {
            let json = JSON.parse(this.jsonOverride);
            this.getJson(json)
                .then(response => {
                    let report = this.reportServer + json.report.report_name + '.pdf?net.sf.jasperreports.json.source=' + response;
                    let preview = this.reportServer + json.report.report_name + '.html?net.sf.jasperreports.json.source=' + response;
                    console.log(preview);
                    this.getReport(report)
                        .then(reportUrl => this.createDialog({ "title": "Success", "body": 'Please click to view your report: <a href="' + reportUrl + '" target="_reports">Click to View</a>', "buttonNo": false, "buttonYesLabel": "OK"  })
                    );
                })
                .catch(error => console.log(error));
            ;
        },

        sumRecursive(object, amountField) {
            let sum = Object.keys(object).reduce(function(prev, current, index) {
                return prev + (+ object[current][amountField]);
            }, 0);

            if (sum.toFixed(2) === '-0.00') {
                return '0.00';
            } else {
                return sum.toFixed(2);
            }
        },

        // function to go through all transaction lines and put them into account order
        parseTransactions (datetimeStart, datetimeEnd) {
            // console.log (datetimeStart);
            // console.log (datetimeEnd);
            // console.log (this.transactionTypes);
            // Load transactions that are marked as "included"
            if (this.includePOs === true) this.transactionTypes.find(( {name} ) => name === 'PO').include = true;
            else this.transactionTypes.find(( {name} ) => name === 'PO').include = false;
            let types = Object.keys(this.transactionTypes.filter(( {include} ) => include === true)).map(key => this.transactionTypes[key].type);

            // Initialize the array to store transactions
            this.showData[this.showName].sortedAccounts = [];
            // if (! this.showData[this.showName].hasOwnProperty(sortedAccounts)) this.showData[this.showName].sortedAccounts = [];

            let work = new Promise((resolve) => {
                let unsorted = [];
                types.forEach((transType) =>{
                    this.showData[this.showName][transType].forEach((trans, index) => {
                        if (trans.lines && trans.lines.length > 0 && (trans.status === 'POSTED' || trans.status === 'CLOSED')) {
                            // Skip if outside of date range.  POs don't have a date posted
                            if (transType == 'PO' && new Date(trans.date) > datetimeStart && new Date(trans.date) < datetimeEnd) {
                                console.log ('Skipping PO ' + trans.id);
                                // Do nothing
                            } else if (transType == 'CK' && new Date(trans.date) > datetimeStart && new Date(trans.date) < datetimeEnd) {
                                console.log ('Skipping CK ' + trans.id);
                                // Do nothing
                            } else if (new Date(trans.time_posted) < datetimeStart || new Date(trans.time_posted) > datetimeEnd) {
                                console.log ('Skipping ' + transType + ' ' + trans.id + ': ' + new Date(trans.time_posted));
                                // Do nothing
                            } else {


                            // hack to skip voids
                            if (trans.description.match(/^Voided/) && trans.number.match(/^VX/) ) {
                                // Skip
                            } else {
                                for (let line of trans.lines) {
                                    // lookup code by user code, not id
                                    let code = this.showData[this.showName].accounts.find(( {id} ) => { return (id === line.account) }).code
                                    let typeLabel = this.transactionTypes.find (( {type} ) => type === transType).name
                                    let accountType = this.showData[this.showName].accounts.find(( {id} ) => { return (id === line.account) }).type
                                    let lineFixed = this.transformLine(line, trans, typeLabel);

                                    if (this.expensesOnly === true && ! accountType.match(/^expense/i)) {
                                        lineFixed = undefined;
                                    }
                                    // lookup/transform data to the line

                                    if (lineFixed != undefined) {
                                        if (! this.showData[this.showName].sortedAccounts[code]) {
                                            this.showData[this.showName].sortedAccounts[code] = [];
                                        }
                                        this.showData[this.showName].sortedAccounts[code].push(lineFixed);
                                    }
                                };
                            }


                            }
                        }
                    });
                });
                resolve(true);

            });
            return work;
        },

        // function to go through all check lines and put them into account order
        addChecks () {
            return  new Promise((resolve) => {
                this.showData[this.showName].checks.forEach((trans, index) => {
                    if (trans.status === 'POSTED' && trans.status === 'CLOSED') {
                        // lookup code by user code, not id
                        let code_cash = this.showData[this.showName].accounts.find(( {id} ) => { return (id === trans.account_cash) }).code
                        let code_clearing = this.showData[this.showName].accounts.find(( {id} ) => { return (id === trans.account_clearing) }).code
                        // lookup/transform data to the line
                        let line_clearing = this.transformLine(trans, trans, 'CK');
                        let line_cash = Object.assign({}, line_clearing);
                        line_cash.amount = line_cash.amount * -1;

                        if (! this.showData[this.showName].sortedAccounts[code_cash]) {
                            this.showData[this.showName].sortedAccounts[code_cash] = [];
                        }
                        if (! this.showData[this.showName].sortedAccounts[code_clearing]) {
                            this.showData[this.showName].sortedAccounts[code_clearing] = [];
                        }
                        this.showData[this.showName].sortedAccounts[code_cash].push(line_cash);
                        this.showData[this.showName].sortedAccounts[code_clearing].push(line_clearing);
                    }
                });
                resolve(true);
            });
         },

        // function to go through all accounts and put them into their groups
        groupAccounts () {
            let scope = this;
            let headers = this.showData[this.showName].accounts.filter(( {type} ) => { return (type.toLowerCase() === 'header'); } );
            let nonHeaders = this.showData[this.showName].accounts.filter(( {type} ) => { return (type.toLowerCase() !== 'header'); } );

            nonHeaders.map((account, ind) => {
                let parentId = account.parent;
                let parentCode = scope.showData[this.showName].accounts.find(( {id} ) => { return (id === account.parent) }).code
                let parentObj = headers.find(( {id} ) => { return (id === parentId) });
                if (! parentObj.accounts) {
                    parentObj.accounts = [];
                }
                parentObj.accounts.push(account);
                // console.log (parentCode, parentId);
            });

            // console.log (headers);
            this.showData[this.showName].groupedAccounts = headers;
            return true;
        },

        sortByProperty(objArray, prop, direction){
            if (arguments.length<2) throw new Error("ARRAY, AND OBJECT PROPERTY MINIMUM ARGUMENTS, OPTIONAL DIRECTION");
            if (!Array.isArray(objArray)) throw new Error("FIRST ARGUMENT NOT AN ARRAY");
            const clone = objArray.slice(0);
            const direct = arguments.length>2 ? arguments[2] : 1; //Default to ascending
            const propPath = (prop.constructor===Array) ? prop : prop.split(".");
            // console.log (clone);
            // console.log (propPath);
            clone.sort(function(a,b){
                for (let p in propPath){
                    // console.log (a);
                    // console.log (b);
                    if (a[propPath[p]] && b[propPath[p]]){
                        a = a[propPath[p]];
                        b = b[propPath[p]];
                    }
                }
                // convert numeric strings to integers
                (isNaN(a)) ? a : +a;
                (isNaN(b)) ? b : +b;
                return ( (a < b) ? -1*direct : ((a > b) ? 1*direct : 0) );
            });
            return clone;
        },

        // Get the line data from the transction and convert the ids into accounting segments
        transformLine(line, transaction, type) {
            if (! line || ! transaction || ! type) return undefined;

            let lineNew = {}; // converted line

            // specific data for Cks
            if (type === 'CK') {
                // console.log('CK', transaction.number, line.status, line.amount_decimal, line.related_transactions);
                lineNew.amount = line.amount_decimal;
                lineNew.period = line.period;
                lineNew.status = line.status;
                lineNew.check_number = line.number;
                lineNew.check_date = line.date;
                lineNew.check_printed = line.time_posted;
                lineNew.check_vendor = line.vendor;
                lineNew.related_transactions = line.related_transactions;
            // specific data for POs
            } else if (type === 'PO') {
                // console.log('PO', transaction.number, line.type, line.amount_decimal, line.remaining_decimal);
                lineNew.account = this.showData[this.showName].accounts.find(( {id} ) => { return (id === line.account); }).code;
                lineNew.period = transaction.period;
                lineNew.vendor_name = (transaction.vendor) ? this.showData[this.showName].vendors.find(( {id} ) => { return (id === transaction.vendor); }).name : null;
                lineNew.vendor_id = transaction.vendor;
                if (line.type === 'OPEN' || line.type === 'PARTIAL') {
                    // lineNew.amount = (line.amount_decimal*1 - line.remaining_decimal*1);
                    lineNew.amount = (line.remaining_decimal*1);
                } else if (line.type === 'ADJUSTMENT') {
                    // lineNew.amount = (line.amount_decimal*1);
                    return undefined;
                } else {
                    // Ignore 
                    // lineNew.amount = (line.amount_decimal*1);
                    // console.log(line.type + ' ' + line.remaining_decimal + ' ' + line.amount_decimal);
                    return undefined;
                }
            } else if (type === 'AP') {
                lineNew.amount = line.amount_decimal;
                lineNew.account = this.showData[this.showName].accounts.find(( {id} ) => { return (id === line.account); }).code;
                lineNew.period = transaction.period;
                lineNew.vendor_name = (transaction.vendor) ? this.showData[this.showName].vendors.find(( {id} ) => { return (id === transaction.vendor); }).name : null;
                lineNew.vendor_id = transaction.vendor;
                if (line.relieves) {
                    let po = this.showData[this.showName].pos.find(( {id} ) => { return (id === line.relieves); });
                    if (po && po.number) lineNew.po_number = po.number;
                }

                if (transaction.payment_type === 'CHECK') {
                    let payment = this.showData[this.showName].checks.find(( {related_transactions} ) => related_transactions.includes(transaction.id));
                    if (payment && payment.number) lineNew.payment_number = payment.number;
                } else if (transaction.payment_type === 'CHECK_MANUAL' && transaction.payment_confirmation_number) {
                    lineNew.payment_number = transaction.payment_confirmation_number + '(MC)';
                }
            } else {
                lineNew.amount = line.amount_decimal;
                lineNew.account = this.showData[this.showName].accounts.find(( {id} ) => { return (id === line.account); }).code;
                lineNew.period = transaction.period;
                lineNew.vendor_name = (transaction.third_party_vendor) ? this.showData[this.showName].vendors.find(( {id} ) => { return (id === transaction.third_party_vendor); }).name : null;
                lineNew.vendor_id = transaction.vendor;
            }

            // Common to all lines
            lineNew.account_desc = (line.account) ? this.showData[this.showName].accounts.find(( {id} ) => { return (id === line.account); }).name : null;
            lineNew.account_header = (line.code) ? this.showData[this.showName].accounts.find(( {id} ) => { return (id === line.account); }).code : null;
            lineNew.series = (line.series) ? this.showData[this.showName].series.find(( {id} ) => { return (id === line.series); }).code : null;
            lineNew.location = (line.location) ? this.showData[this.showName].locations.find(( {id} ) => { return (id === line.location); }).code : null;
            lineNew.set = (line.set) ? this.showData[this.showName].sets.find(( {id} ) => { return (id === line.set); }).code : null;
            lineNew.free_field_1 = (line.free_field_1) ? this.showData[this.showName].freefields.find(( {id} ) => { return (id === line.free_field_1); }).code : null;
            lineNew.free_field_2 = (line.free_field_2) ? this.showData[this.showName].freefields.find(( {id} ) => { return (id === line.free_field_2); }).code : null;
            lineNew.free_field_3 = (line.free_field_3) ? this.showData[this.showName].freefields.find(( {id} ) => { return (id === line.free_field_3); }).code : null;
            lineNew.free_field_4 = (line.free_field_4) ? this.showData[this.showName].freefields.find(( {id} ) => { return (id === line.free_field_4); }).code : null;
            lineNew.insurance = (line.insurance) ? this.showData[this.showName].insurances.find(( {id} ) => { return (id === line.insurance); }).code : null;
            lineNew.asset = (line.asset) ? line.asset : null;
            lineNew.tax_code = (line.tax_code) ? this.showData[this.showName].countrytaxcodes.find(( {id} ) => { return (id === line.tax_code); }).code : null;
            lineNew.line_desc = line.description;

            // Add header info to line
            lineNew.trans_type = type;
            lineNew.trans_number = transaction.ledger;
            lineNew.doc_date = transaction.date;
            lineNew.doc_number = transaction.number;

            return lineNew;
        },

        today() {
            let date = new Date(),
                mm = date.getMonth() + 1,
                dd = date.getDate();

            return [date.getFullYear(),
                (mm>9 ? '' : '0') + mm,
                (dd>9 ? '' : '0') + dd
            ].join('/');
        },

        validateData() {
            let index = [];

            let errors = this.journalLines.filter(({account, series}, ind ) => {
                if (account == null || series == null) { index.push(ind); };
                return (account == null || series == null);
            });

            if (errors.length === 0) return true;

            for ( let i = 0; i < index.length; i++) {
                let tableIndex = parseInt(index[i]) + 1
                // console.log (tableIndex);
                $($("#payrollData table tr")[tableIndex]).addClass("form-error");
            }
            for ( let i = 0; i < errors.length; i++) {
                console.log (errors[i]);
            }
        },

        getJson(json) {
            return new Promise ((resolve, reject) => {
            let data = { json: json }
            this.oasisApi.post('/addJson', data)
                .then(response => {
                    if (response.status === 200) {
                        return resolve(response.data);
                    } else {
                        return reject(response);
                    }
                })
                .catch(error => reject(error));
            ;
            });
        },

        getReport(url) {
            return new Promise ((resolve, reject) => {
            let data = { url: url }
            this.oasisApi.post('/getReport', data)
                .then(response => {
                    if (response.status === 200) {
                        return resolve(response.data);
                    } else {
                        return reject(response);
                    }
                })
                .catch(error => reject(error));
            ;
            });
        },

        // pad 1-digit months/days
        pad(n) {
            return n < 10 ? '0' + n : n;
        },

        modalClose() {
            this.showLogin = false;
        },

        // Create a dynamic modal dialog box with buttons and labels
        createDialog(options) {
            let index = this.openModals;
            options.id = index;

            if (options.buttonYesAction) { this.buttonYesAction[index] = options.buttonYesAction;
            } else { this.buttonYesAction[index] = function () {}; }

            if (options.buttonYesLabel) { this.buttonYesLabel = options.buttonYesLabel;
            } else { options.buttonYesLabel = 'Yes'; }

            if (options.buttonNoAction) { this.buttonNoAction[index] = options.buttonNoAction;
            } else { this.buttonNoAction[index] = function () {}; }

            if (options.buttonNoLabel) { this.buttonNoLabel = options.buttonNoLabel;
            } else { options.buttonNoLabel = 'No'; }

            if (options.button3Action) { this.button3Action[index] = options.button3Action;
            } else { this.button3Action[index] = function () {}; }

            if (options.button3Label) { this.button3Label = options.button3Label;
            } else { options.button3Label = 'Maybe'; }

            this.modals.push(options);
            this.openModals++;
        },

        // Close the dynamic modal
        closeModal(index) {
            this.modals.splice(index, 1);
            this.buttonYesAction.splice(index, 1);
            this.buttonNoAction.splice(index, 1);
            this.button3Action.splice(index, 1);
            this.openModals--;
        },

        modalConfirm(index) {
            this.buttonYesAction[index]();
        },

        modalCancel(index) {
            this.buttonNoAction[index]();
        },

        modalButton3(index) {
            this.button3Action[index]();
        },
    },

    watch: {
    },

    created() {
        if (localStorage.getItem('showData')){
            this.showData = JSON.parse(localStorage.getItem('showData'));
        }
    },

    beforeCreate() {
    },

    mounted() {
        // Load data provided by server, if any
        $("#login").focus();
        if (this.showData[this.showName] && this.showData[this.showName].token) {
            this.showToken = this.showData[this.showName].token;
        } else {
            this.showData[this.showName] = {};
            this.showLogin = true;
        }

        this.forceDataReload();
    }

}).mount("#sigma-reports");